<template>
  <v-dialog
      ref="dialog"
      v-model="open"
      persistent
      width="300px"
  >
    <v-card>
      <v-card-title>{{ name }}</v-card-title>
      <div class="qr">
        <a :href="url" target="_blank" style="margin-top: 12px;display: inline-block;">
          <qrcode-vue :value="url" :size="200" level="H"/>
        </a>
      </div>
      <v-card-actions>

        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            text
            @click="open = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style lang="scss" scoped>
.qr {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<script lang="ts">

import {Component, Vue} from 'vue-property-decorator'
import QrcodeVue from 'qrcode.vue'

@Component({
  components: {QrcodeVue}
})
export default class QrDialog extends Vue {

  open: boolean = false
  url: string = ''
  name: string = 'QR link'

  onApply: Function = () => {
  }

  created() {
    this.$root.$on('openQr', this.onOpen)
  }

  onOpen({url, name}) {
    if (this.open) return
    console.log('Emitted', {url})
    this.url = url
    this.name = name

    this.open = true

    // this.onApply = onApply
  }

};

</script>
